import type { Enums, Nullable } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getAttendanceSourceIconName(source: Nullable<Enums<"attendanceSource">>): IconName {
	switch (source) {
		case "web":
			return "Monitor";
		case "mobile":
			return "Smartphone";
		case "terminal":
			return "Tablet";
		case "system":
			return "Server";
		default:
			return "CircleQuestionMark";
	}
}
